<template>
    <footer>
        <span v-if="$route.name !== 'Legal' && $route.name !== 'MStarLegal'">
            <router-link :to="getLegalLink">{{ $t('LegalDisclamerLink') }}</router-link> | 
        </span>
        <span class="copyright">{{ $t('Copyright', { year: currentYear }) }}</span>
    </footer>
</template>

<script>
export default {
    data () {
        return {
            routeToUse: this.$router.currentRoute.path.toLowerCase().includes('morningstarlifetimeindexfunds') ? 'mstar' : ''
        };
    },
    computed: {
        currentYear () {
            return new Date().getFullYear();
        },
        getLegalLink() {
            console.info('temp', this.routeToUse);
            return this.routeToUse === 'mstar' ? '/MorningstarLifetimeIndexFunds/legal' : '/legal';
        }
    },
    watch: {
        $route(to, from) {
            this.routeToUse = to.path.toLowerCase().includes('morningstarlifetimeindexfunds') ? 'mstar' : '';
        }
    }
};
</script>

<style lang="scss" scoped>
#app {
    footer {
        margin: $mds-space-4-x auto;
        text-align: center;
        @include mds-font-reset;
        color: $mds-color-neutral-80;
        font-size: $mds-font-size-s;
        padding: 0 $mds-space-4-x;

        a {
            color: $mds-color-neutral-80;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue